/**
 * @author NikolaV
 */
import * as React from 'react';
import { Distance } from '../ui/shared/format-components';
import { observer } from 'mobx-react';
import { GroupRange, ITripStatsSum } from '../store/StatsStore';
import { DateSpan } from '@shared/ui-react/UtilComponents';
import { DateUtils } from '@shared/utils/DateUtils';


@observer
export class MaterialStatsTableTBody extends React.Component<{
    stats: ITripStatsSum,
    groupedBy: GroupRange
}> {
    render() {
        const stats = this.props.stats;

        return (
            <tbody>
            {stats.items.map((s, i) => <tr key={i}>
                {this.renderFirstCell(i)}
                <td>{s.material.material}</td>
                <td>{s.m2 > 0 ? parseFloat(s.m2.toFixed(2)) : null}</td>
                <td>{s.tons > 0 ? parseFloat(s.tons.toFixed(2)) : null}</td>
                <td>{s.pieces > 0 ? parseFloat(s.pieces.toFixed(2)) : null}</td>
                <td>{DateUtils.secondsToDateTime(s.tripTime)}</td>
                <td>{s.tripsCount}</td>
                <td><Distance distance={s.distance}/></td>
                <td><Distance distance={s.distance / s.tripsCount}/></td>
            </tr>)}

            {stats.items.length > 1 && (
                <tr>
                    <td>{__('trucks.trips.table_total')}</td>
                    <td>{parseFloat(stats.totalM2.toFixed(2))}</td>
                    <td>{parseFloat(stats.totalTons.toFixed(2))}</td>
                    <td>{parseFloat(stats.totalPieces.toFixed(2))}</td>
                    <td>{DateUtils.secondsToDateTime(stats.totalTime)}</td>
                    <td>{stats.totalCount}</td>
                    <td><Distance distance={stats.totalDistance}/></td>
                    <td><Distance distance={stats.totalDistance / stats.totalCount}/></td>
                </tr>
            )}
            </tbody>
        );
    }

    renderFirstCell(rowIndex) { // date cell
        const firstItem = this.props.stats.items[0];
        const count = this.props.stats.items.length;
        const rowSpan = rowIndex === 0 ? count + 1 : null;

        if (rowIndex > 0) return null;

        if (this.props.groupedBy === 'all') {
            return null;
        }
        else if (this.props.groupedBy === 'day') {
            return <td rowSpan={rowSpan}><DateSpan timestamp={firstItem.date}/></td>;
        }
        else if (this.props.groupedBy === 'week') {
            return <td rowSpan={rowSpan}>{firstItem.weekAndYear}</td>;
        }
        else if (this.props.groupedBy === 'month') {
            return <td rowSpan={rowSpan}>{firstItem.monthAndYear}</td>;
        }
    }
}
